import Logo1 from "../../assets/footer1.svg";
import Logo2 from "../../assets/footer2.svg";
import Logo3 from "../../assets/footer3.svg";
import Logo4 from "../../assets/footer4.svg";
import Logo5 from "../../assets/footer6.svg";
import Logo6 from "../../assets/footer7.svg";

import { Link } from "react-router-dom";

const logos = [Logo1, Logo2, Logo3, Logo4, Logo5, Logo6];

const socialLinks = [
  {
    url: "https://www.linkedin.com/company/ethio-telecom",
    label: "LinkedIn",
  },
  {
    url: "https://t.me/ethio_telecom",
    label: "Telegram",
  },
  {
    url: "https://twitter.com/ethiotelecom",
    label: "Twitter",
  },
  {
    url: "https://www.facebook.com/ethiotelecom",
    label: "Facebook",
  },
  {
    url: "https://www.instagram.com/ethiotelecom/",
    label: "Instagram",
  },
  {
    url: "https://www.youtube.com/c/EthiotelecomETH",
    label: "YouTube",
  },
];

const NewFooter = () => {
  return (
    <footer className="hidden md:block md:w-full bg-gray-100 py-4 px-6 shadow-sm">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
        <div className="text-gray-600 text-sm">
          <a href="/terms" className="hover:underline">
            Term and Conditions
          </a>{" "}
          |{" "}
          <a href="/privacy" className="hover:underline">
            Privacy Policy
          </a>{" "}
          |{" "}
          <a href="/contact" className="hover:underline">
            Contact Us
          </a>{" "}
          |{" "}
          <a href="/faq" className="hover:underline">
            FAQ
          </a>
        </div>

        <div className="flex items-center gap-3">
          {logos.map((Logo, index) => (
            <a
              key={index}
              href={socialLinks[index].url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={socialLinks[index].label}
              className="rounded-full hover:opacity-90 flex items-center justify-center w-8 h-8"
            >
              <img src={Logo} className="w-full h-full" />
            </a>
          ))}
        </div>

        <div className="text-gray-600 text-sm">
          © Ethio telecom 2025, All rights reserved
        </div>
      </div>
    </footer>
  );
};

export default NewFooter;
